import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'app-notification-pwa-install',
  templateUrl: './notification-pwa-install.component.html',
  styleUrls: ['./notification-pwa-install.component.scss']
})
export class NotificationPwaInstallComponent implements OnInit {

  showIosInstallNotification = false;
  showAndroidInstallNotification = false;
  showAndroidAfterInstallNotification = false;
  disableAndroidInstalationNotification = false; // disables notification permanently
  crurrentDomain: string;
  private androidPromptEvent: any;

  constructor(
    private swUpdate: SwUpdate,
    private platform: Platform,
    private location: Location
  ) { }

  ngOnInit() {
    // Disable PWA install for client and session views 
    const url = this.location.path();
    const isDisabledForUrl = url.includes('/map/') || url.includes('/queue/') || url.includes('/session/') || url.includes('/upload/') || url.includes('/signup');

    // Android
    if (this.swUpdate.isEnabled && this.platform.ANDROID && !isDisabledForUrl) {
      // Catch before install event
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.androidPromptEvent = event;
        this.showAndroidInstallNotification = true;
      });

      // Catch app installed event 
      window.addEventListener('appinstalled', e => {
        // Delay notification a bit, wait for system notification to hide
        setTimeout(() => {
          this.showAndroidAfterInstallNotification = true;
          // Get current domain to redirect user to PWA app
          // this.crurrentDomain = this.router.url;
        }, 3000);
      });
    }

    // iOS
    if (this.swUpdate.isEnabled && this.platform.IOS && !isDisabledForUrl) {
      const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
      if (!isInStandaloneMode) {
        this.showIosInstallNotification = true;
      }
    }
  }

  onCloseNotification() {
    this.showAndroidInstallNotification = false;
    this.showAndroidAfterInstallNotification = false;
    this.showIosInstallNotification = false;
  }

  public installPwaOnAndroid(): void {
    this.showAndroidInstallNotification = false;

    // Show the install prompt
    this.androidPromptEvent.prompt().then(userChoice => {
      console.log("Prompted, result = ", userChoice);
      switch (userChoice.outcome) {
        case "accepted":
          this.showAndroidInstallNotification = false;
          this.disableAndroidInstalationNotification = true;
          break;
        case "dismissed":
          this.showAndroidInstallNotification = false;
          this.disableAndroidInstalationNotification = true;
          break;
      }
    })
      .catch(reason => {
        console.error("Could not prompt", reason);
      });
  }
}
